module.exports = __webpack_public_path__ + "img/imlatte-logo.8b5792ce.png";